import { Box, Flex, Heading, IconButton, Text } from '@chakra-ui/react';
import Filter from '../icons/Filter';
import { format } from 'date-fns';
import Transaction from '../components/Transaction';
import PageHeader from '../components/PageHeader';
import { gql, useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';

const GET_SUBSCRIPTION_QUERY = gql`
  query GetSubscriptionById($id: uuid!) {
  subscriptions_by_pk(id: $id) {
    id
    invoice_interval
    created_at
    updated_at
    metadata
    subscription_start
    subscription_end
    subscription_items {
      id
      is_voided
      void_reason
      quantity
      subscription_payment_transactions(limit: 4, order_by: {created_at: desc}) {
        id
        amount
        created_at
        invoice {
          id
          due_at
        }
        product_item {
          id
          name
        }
      }
    }
    subscription_details {
      id
      value
      form_field {
        id
        field_name
      }
    }
  }
}

`;

const Transactions = () => {
  let { transactionId } = useParams<{ transactionId: string }>();

  const { data, loading } = useQuery(GET_SUBSCRIPTION_QUERY, {
    variables: { id: transactionId },
    // client: cl
  })


  console.log({ data })
  return (
    <>
      <PageHeader title='Transactions' />

      <Box pl={5} pr={4} py={3} mt='75px'>
        <Flex justify='space-between' alignItems='center'>
          <Heading as='h5' size='sm' ml={1}>
            History
          </Heading>
          <IconButton
            icon={<Filter stroke='#fff' />}
            size='sm'
            fontSize='16px'
            background='#2563eb'
            aria-label='Filter Transactions'
          />
        </Flex>

        <Text color='#64748b' fontWeight='medium' mb={3} mt={5} ml={1}>
          {format(new Date(), 'MMM, yyyy')}
        </Text>

        <Box
          borderWidth='1px'
          borderRadius='xl'
          background='#fff'
          py={3}
          pl={3}
          pr={2}
        >
          <Transaction
            description='Loan disbursment'
            createdAt='10 Aug, 2023 at 11.34 AM'
            amount='34000'
            type='debit'
            id='1'
          />
          <Transaction
            description='Repayment'
            createdAt='10 Aug, 2023 at 11.34 AM'
            amount='4000'
            type='credit'
            id='2'
          />
          <Transaction
            description='Repayment'
            createdAt='10 Aug, 2023 at 11.34 AM'
            amount='1400'
            type='credit'
            id='3'
          />
          <Transaction
            description='Repayment'
            createdAt='10 Aug, 2023 at 11.34 AM'
            amount='400'
            type='credit'
            id='4'
          />
        </Box>

        <Text color='#64748b' fontWeight='medium' mb={3} mt={5} ml={1}>
          {format(new Date(), 'MMM, yyyy')}
        </Text>

        <Box
          borderWidth='1px'
          borderRadius='xl'
          background='#fff'
          py={3}
          pl={3}
          pr={2}
        >
          <Transaction
            description='Loan disbursment'
            createdAt='10 Aug, 2023 at 11.34 AM'
            amount='34000'
            type='debit'
            id='5'
          />
          <Transaction
            description='Repayment'
            createdAt='10 Aug, 2023 at 11.34 AM'
            amount='4000'
            type='credit'
            id='6'
          />
          <Transaction
            description='Repayment'
            createdAt='10 Aug, 2023 at 11.34 AM'
            amount='1400'
            type='credit'
            id='7'
          />
          <Transaction
            description='Repayment'
            createdAt='10 Aug, 2023 at 11.34 AM'
            amount='400'
            type='credit'
            id='8'
          />
        </Box>

        <Text color='#64748b' fontWeight='medium' mb={3} mt={5} ml={1}>
          {format(new Date(), 'MMM, yyyy')}
        </Text>

        <Box
          borderWidth='1px'
          borderRadius='xl'
          background='#fff'
          py={3}
          pl={3}
          pr={2}
        >
          <Transaction
            description='Loan disbursment'
            createdAt='10 Aug, 2023 at 11.34 AM'
            amount='34000'
            type='debit'
            id='9'
          />
          <Transaction
            description='Repayment'
            createdAt='10 Aug, 2023 at 11.34 AM'
            amount='4000'
            type='credit'
            id='10'
          />
          <Transaction
            description='Repayment'
            createdAt='10 Aug, 2023 at 11.34 AM'
            amount='1400'
            type='credit'
            id='11'
          />
          <Transaction
            description='Repayment'
            createdAt='10 Aug, 2023 at 11.34 AM'
            amount='400'
            type='credit'
            id='12'
          />
        </Box>

      </Box>
    </>
  );
};

export default Transactions;
